// extracted by mini-css-extract-plugin
module.exports = {"description":"HGScUeChVWdwT7urw9QW"};